import React, { useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Typography from '@material-ui/core/Typography';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import Box from '@material-ui/core/Box';
import RaisedButton from 'material-ui/RaisedButton';
import globals from '../../../globals/communityGlobals';
import NonPatientActivityCreate from '../../../containers/NonPatientActivities/NonPatientActivityCreateContainer';
import { createNonPatientActivity } from '../../../actions/entities';

const locale = globals.getArea('nonPatientActivities');
const npaDetailsDefault = {
  nonPatientActivityTypeId: null,
  notes: '',
  orgUnitIds: [],
  clinicianIds: [],
};

const npaAddressDefault = {
  addressLine1: '',
  addressLine2: '',
  addressLine3: '',
  postCode: '',
  townCity: '',
};

export default function AddNpaPlanningForm({ onClose, orgUnitId, selectedDate, resetAndReload }) {
  const dispatch = useDispatch();

  const npaScheduleDefault = {
    dateFrom: selectedDate,
    dateTo: selectedDate,
    duration: '',
    startTime: '',
    endTime: '',
    recurEvery: 1,
    recurrenceType: 'None',
    selectedDays: '',
  };

  const [canSave, setCanSave] = useState(false);
  const npaDetailsRef = useRef(npaDetailsDefault);
  const npaScheduleRef = useRef(npaScheduleDefault);
  const npaAddressRef = useRef(npaAddressDefault);

  const getNpaDetails = details => {
    npaDetailsRef.current = details;
  };

  const getNpaSchedule = schedule => {
    npaScheduleRef.current = schedule;
  };

  const getNpaAddress = address => {
    npaAddressRef.current = address;
  };

  const handleSave = () => {
    const npaDetails = npaDetailsRef.current;
    const npaSchedule = npaScheduleRef.current;
    const npaAddress = npaAddressRef.current !== null ? npaAddressRef.current.address : null;

    const NonPatientActivity = {
      nonPatientActivityTypeId: npaDetails.NonPatientActivityTypeId,
      notes: npaDetails.notes,
      orgUnitIds: npaDetails.orgUnitIds,
      clinicianIds: npaDetails.clinicianIds,
      dateFrom: npaSchedule.dateFrom,
      dateTo: npaSchedule.dateTo,
      duration: npaSchedule.duration,
      startTime: npaSchedule.startTime,
      endTime: npaSchedule.endTime,
      recurEvery: npaSchedule.recurEvery,
      recurrenceType: npaSchedule.recurrenceType,
      selectedDays: npaSchedule.selectedDays,
      address: npaAddress,
    };

    dispatch(createNonPatientActivity({ NonPatientActivity }, true)).then(response => {
      if (response) {
        onClose();
        resetAndReload();
      }
    });
  };

  const headerRender = () => {
    return (
      <div className="sidePanel-header form-header">
        <div className="sidePanel-header-subtitle">
          <Box display="flex">
            <Box flexGrow={1} py={1}>
              <Typography variant="subtitle1">Create activity</Typography>
            </Box>
            <Box>
              <IconButton onClick={onClose}>
                <CancelIcon />
              </IconButton>
            </Box>
          </Box>
        </div>
      </div>
    );
  };

  const addNPAFormRender = () => {
    return (
      <form className="sidePanel-content content-top-padding" autoComplete="off" disabled="disabled">
        <NonPatientActivityCreate
          orgUnitId={orgUnitId}
          selectedDate={selectedDate}
          shouldAssignToday
          canSaveFromPlanning={setCanSave}
          getNpaDetails={details => getNpaDetails(details)}
          getNpaSchedule={schedule => getNpaSchedule(schedule)}
          getNpaAddress={address => getNpaAddress(address)}
        />
      </form>
    );
  };

  const footerRender = () => {
    return (
      <div className="sidePanel-footer">
        <div style={{ float: 'right' }} className="sidePanel-buttons">
          <RaisedButton
            type="submit"
            label={locale.getMsg('assignActivity')}
            onClick={() => handleSave()}
            primary
            disabled={!canSave}
          />
        </div>
      </div>
    );
  };

  return (
    <section className="side-panel-content-wrapper">
      <SwipeableDrawer anchor="right" open onOpen={() => {}} onClose={() => onClose()}>
        <div className="sidePanel-wrapper" style={{ width: '700px' }}>
          {headerRender()}
          {addNPAFormRender()}
          {footerRender()}
        </div>
      </SwipeableDrawer>
    </section>
  );
}
